<template>
  <MainLayout>
    <Head>
      <title>{{ title }}</title>
    </Head>

    <template v-slot:header>
      <span ref="topAnchor">
        {{ title }}
      </span>
    </template>

    <FormWrapper grid>
      <form @submit.prevent="submit">
        <div class="section">
          <FormInput name="name"
                     v-model="form.name"
                     :errors="errors"
                     class="sm:col-span-4"/>

          <FormInput name="email"
                     v-model="form.email"
                     :errors="errors"
                     class="sm:col-span-4"/>

          <div class="sm:col-span-2"></div>

          <FormSelect name="role"
                      v-model="form.role"
                      :errors="errors"
                      :options="roles"
                      v-if="$can('roles.write')"
                      class="sm:col-span-2" />
        </div>

        <div class="section">
          <FormInput name="password"
                     v-model="form.password"
                     :errors="errors"
                     type="password"
                     class="sm:col-span-4"/>
          <FormInput name="password_confirmation"
                     v-model="form.password_confirmation"
                     :errors="errors"
                     type="password"
                     class="sm:col-span-4"/>
        </div>

        <FormActions :cancelUrl="$route('users.index')"
                     grid
                     :show-submit="$can('users.write')"/>
      </form>
    </FormWrapper>
  </MainLayout>
</template>

<script>
import PageComponent from '@/pages/page-component'
import FormComponent from '@/pages/form-component'
import { Inertia } from '@inertiajs/inertia'
import MultiOptionPicker from '@/components/multi-option-picker.vue'
import UsesPermissions from '@/mixins/uses-permissions'

export default {
  mixins: [
    PageComponent,
    FormComponent,
    UsesPermissions,
  ],

  components: {
    MultiOptionPicker,
  },

  props: {
    model: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    errors: Object,
    roles: Array,
    userRole: Object,
  },

  data() {
    return {
      title: `Users :: ${this.model?.name}`,
      form: {
        name: this.model?.name,
        email: this.model?.email,
        password: null,
        password_confirmation: null,
        role: this.userRole?.name,
      },
    }
  },

  methods: {
    submit() {
      Inertia.put(this.$route('users.update', [this.model.id]), this.form)
    },
  },
}
</script>
